<template>
  <div>
    <div class="table-responsive">
      <table class="table v-middle border">
        <thead>
          <tr class>
            <th class="col">Societé</th>
            <th class="col"></th>
            <th class="col"></th>
          </tr>
        </thead>
        <tbody v-for="(pack, i) in listes_somme" v-bind:key="'sum' + i">
          <tr>
            <td class="col">
              {{ pack.nom }}
              <img
                @click="delete_societe(pack.id)"
                
                style="margin-left: 3px;width: 24px;"
                src="https://img.icons8.com/external-dreamstale-lineal-dreamstale/32/000000/external-delete-interface-dreamstale-lineal-dreamstale-2.png"
              />
              <router-link
                :to="{
                  name: 'modif_societe',
                  params: { id: pack.id },
                }"
              >
                <img
                  style="margin-left: 11px"
                  src="https://img.icons8.com/office/16/000000/edit.png"
                />
              </router-link>
            </td>
            <td class="col">
              <router-link
                :to="{
                  name: 'Somme-TVA',
                  params: { id: pack.id },
                }"
              >
                <CButton
                  style="
                    margin-bottom: 7px;
                    border-radius: 15px 18px;
                    margin-top: 0px;
                    margin-left: -8px;
                  "
                  color="danger"
                  class="mr-1 cl"
                >
                  Total
                </CButton>
              </router-link>
            </td>
            <td class="col">
              <router-link
                :to="{
                  name: 'factures_service_societe',
                  params: { id: pack.id },
                }"
              >
                <CButton
                  style="
                    margin-bottom: 7px;
                    border-radius: 15px 18px;
                    margin-top: 0px;
                    margin-left: -8px;
                  "
                  color="warning"
                  class="mr-1 cl"
                >
                  Service
                </CButton>
              </router-link>
            </td>
            <td class="col">
              <router-link
                :to="{
                  name: 'factures_vidange_societe',
                  params: { id: pack.id },
                }"
              >
                <CButton
                  style="
                    margin-bottom: 7px;
                    border-radius: 15px 18px;
                    margin-top: 0px;
                    margin-left: 16px;
                    padding: 10px;
                  "
                  color="info"
                  class="mr-1 cl"
                >
                  Vidange
                </CButton>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>


<script>
import { apiDomain } from "../../config";
import axios from "axios";

export default {
  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  components: {},
  data() {
    return {
      showdetailleModale: false,
      detaille: {
        id: "",
      },
      index: -1,

      listes_somme: {},
      calcule_somme: {},
      selcet_scociete: "",
      listes_service: {},
      selected: [],
      idsImprimer: [],
      select: "",
      all_select: false,
    };
  },

  created() {
    this.fetchListesTypes();
    this.fetchSomme_en_atente();
  },

  computed: {
    calculSomme: function () {
      const list = this.listes_somme;
      var result = [];
      var somme_calcul = 0;

      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < list[i].facture.length; j++) {
          somme_calcul += list[i].facture[j].somme;

          if (somme_calcul != 0) {
            somme_calcul += list[i].facture[j].somme - somme_calcul;
          }
          continue;
        }
        /*    if (somme_calcul > 0) {
          somme_calcul = 0;
        } */
        result.push(somme_calcul);
      }

      return result;
    },
    somme: function () {
      var sum = [];
      const arr = this.listes_somme;

      /*  arr = [{x:1}, {x:3}] */

      var res = arr.reduce(
        (accumulator, current) => accumulator + current.id,
        0
      );
      return res;
    },
  },

  methods: {
    delete_societe(id) {
      if (confirm("Azouz SVP Vérifier Sure ?")) {
      fetch(`${apiDomain}/api/delete_Societe_servie/${id}`, {
        method: "delete",
      })
        .then((res) => res.json())
        .then((data) => {
          this.$noty.success("Societé supprimer avec Succès ! ");
          this.fetchSomme_en_atente();
        })

        .catch((err) => console.log(err));
      }
    },
    showdetaille(pack) {
      this.detaille = pack;
      this.showdetailleModale = true;
    },

    showEditModal(pack, index) {
      let obj = {
        id: pack.id,
      };
      this.detaille = obj;
      this.showdetailleModale = true;
      this.index = index;
    },
    all_imprimer() {
      axios
        .post(
          `${apiDomain}/api/del2/` + this.idsImprimer
        ) /* + this.idsImprimer */
        .then((response) => {
          this.fetchListesTypes();
          this.idsImprimer = [];
          this.all_select == true
            ? (this.all_select = false)
            : (this.all_select = true);
        });
    },
    select_all_via_check_box() {
      if (this.all_select == false) {
        this.all_select = true;
        this.listes_service.data.forEach((user) => {
          this.idsImprimer.push(user.id);
        });
      } else {
        this.all_select = false;
        this.idsImprimer = [];
      }
    },

    updatedPaye_all(id) {
      fetch(`${apiDomain}/api/UpdatedPayement_all/${this.idsImprimer}`, {
        method: "post",
      })
        .then((res) => res.json())
        .then((data) => {
          this.idsImprimer = "";
          this.fetchListesTypes();
        })

        .catch((err) => console.log(err));
    },

    updatedPaye(id) {
      fetch(`${apiDomain}/api/UpdatedPayement/${id}`, {
        method: "post",
      })
        .then((res) => res.json())
        .then((data) => {
          this.fetchListesTypes();
        })

        .catch((err) => console.log(err));
    },

    updatedENattente_all(id) {
      fetch(
        `${apiDomain}/api/UpdatedPayement_EN_attente_all/${this.idsImprimer}`,
        {
          method: "post",
        }
      )
        .then((res) => res.json())
        .then((data) => {
          this.idsImprimer = "";
          this.fetchListesTypes();
        })

        .catch((err) => console.log(err));
    },

    updatedENattente(id) {
      fetch(`${apiDomain}/api/UpdatedPayement_EN_attente/${id}`, {
        method: "post",
      })
        .then((res) => res.json())
        .then((data) => {
          this.fetchListesTypes();
        })

        .catch((err) => console.log(err));
    },

    delete_service(id) {
      if (confirm("Azouz SVP Vérifier Sure ?")) {
      fetch(`${apiDomain}/api/delete_service/${id}`, {
        method: "delete",
      })
        .then((res) => res.json())
        .then((data) => {
          this.$noty.success("Service  supprimer avec Succès ! ");

          this.fetchListesTypes();
        })

        .catch((err) => console.log(err));
      }
    },
    fetchListesTypes() {
      fetch(`${apiDomain}/api/get_facture`)
        .then((res) => res.json())
        .then((res) => {
          this.listes_service = res.all_service;
        })
        .catch((err) => console.log(err));
    },

    fetchSomme_en_atente() {
      fetch(`${apiDomain}/api/get_somme_Societe_servie_en_attente`)
        .then((res) => res.json())
        .then((res) => {
          this.listes_somme = res;
        })
        .catch((err) => console.log(err));
    },

    /*   fetch_calcul_somme($id) {
      fetch(
        `${apiDomain}/api/get_somme_Societe_servie_en_attente2/${this.detaille.id}`
      )
        .then((res) => res.json())
        .then((res) => {
          this.calcule_somme = res;
        })
        .catch((err) => console.log(err));
    }, */

    getResults(page) {
      if (typeof page === "undefined") {
        page = 1;
      }
      let vm = this;
      fetch(`${apiDomain}/api/get_facture?page=` + page)
        .then((res) => res.json())
        .then((data) => {
          this.listes_service = data.all_service;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style>
.feed {
  background: #fff;
  height: 106px;
  overflow: scroll;
}
.btdelete {
  padding: 11px 27px !important;
  margin-top: 38px;
  border-radius: 5px;
}
/* 
.md-card img {
  width: 55% !important;
  height: auto;
} */

.non_paye {
  position: absolute;
  background: #f10735;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  /*  margin-top: -15.6%; */

  margin-top: -16.6% !important;

  height: 30px;
  line-height: 30px;
  border-radius: 15px;
}

.paye {
  position: absolute;
  background: #28e40c;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  margin-top: -16.6% !important;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
}

.en_attente {
  position: absolute;
  background: #c37600;
  opacity: 0.8;
  display: inline-block;
  padding: 0 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  z-index: 1;
  margin-left: -1.4%;
  /*   margin-top: -15.6%; */

  margin-top: -16.6% !important;

  height: 30px;
  line-height: 30px;
  border-radius: 15px;
}

nav {
  display: flex;
  justify-content: center;
}

.pagination {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}

.pagination li {
  margin: 0 1px;
  padding: 11px 6px !important;
  text-decoration: none;
}

.pagination > .active > a,
.pagination > .active > a:focus,
.pagination > .active > a:hover,
.pagination > .active > span,
.pagination > .active > span:focus,
.pagination > .active > span:hover {
  background-color: #2a357d !important;

  color: #ffffff !important;
  -webkit-box-shadow: 0 4px 5px 0 rgb(28 159 228 / 14%),
    0 1px 10px 0 rgb(28 159 228 / 12%), 0 2px 4px -1px rgb(28 159 228 / 20%);
  box-shadow: 0 4px 5px 0 rgb(28 159 228 / 14%),
    0 1px 10px 0 rgb(28 159 228 / 12%), 0 2px 4px -1px rgb(28 159 228 / 20%);
}

.pagination > li > a,
.pagination > li > span {
  color: fff;
  list-style-type: cercle;
  border: 0;
  border-radius: -16px !important;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  padding: 9px;
  margin: 0 3px;
  min-width: 31px;
  height: 31px;
  line-height: 30px;
  color: #999999;
  font-weight: 400;
  font-size: 11px;
  text-transform: uppercase;
  background: transparent;
  /* border-color: blue !important; */
  border-radius: 4px;
  background-color: #e88e08 !important;
  /* border-color: #000; */
  color: #fff !important;
}

.index {
  display: inline-block;
  height: 36px;
  width: 36px;
  line-height: 36px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  background-color: #e88e08;
  border-radius: 50% !important;
  text-align: center;
  position: relative;
  z-index: 2;
}

.index_new {
  display: inline-block;
  height: 25px;
  width: 25px;
  line-height: 28px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  background-color: #e88e08;
  border-radius: 50% !important;
  text-align: center;
  position: relative;
  z-index: 2;
}

.cer {
  color: rgb(255, 255, 255);
  width: 30px;
  height: 30px;
  line-height: -10px;
  border-radius: 50%;
  font-size: 50px;
  text-align: center;
  background: rgb(245 175 19);
}
.cer_green {
  color: rgb(255, 255, 255);
  width: 30px;
  height: 30px;
  line-height: -10px;
  border-radius: 50%;
  font-size: 50px;
  text-align: center;
  background: #0ef717;
}
</style>

